import React from "react";
import { Link } from "@material-ui/core";
import "./styles.scss";

function NotAuthorized({history}) {
    
    return (
        <div id="notAuthorized">
            <div className="notAuthorized">
                <div className="notAuthorized-401"></div>
                <h1>401</h1>
                <h2>Oops! Your are not authorized</h2>
                <p>Sorry but you don't haver permissions to see this content.</p>
                <Link component="button" variant="body2" onClick={() => history.push("/")}>
                    Back to homepage
                </Link>
            </div>
        </div>
    );
}

export default NotAuthorized;